import { MarketplaceFieldProps } from './types';

export function MarketplaceField({ props: { marketplaceField } }: MarketplaceFieldProps) {
  return <>{marketplaceField.value}</>;
}
